import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LogoutPage from "./Logout";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import { ThemeContext } from "../../../context/ThemeContext";
import ChangePasswordModal from "../../components/ChangePasswordModal";
import { SlUser } from "react-icons/sl";
import { colors } from "../../config/colors";
import { MenuList } from "./Menu";
import { MenuSuperAdmin } from "./MenuSuperAdmin";
import { getJobTitleLabel } from "../../utils/jobTitleLabel";
import logo from '../../../images/logo.png'
import { FaBars } from "react-icons/fa";
import JobActivityService from "../../../services/JobActivityService";
import { IoNotificationsOutline } from "react-icons/io5";
import TutorialModal from "../../components/Tutorial/TutorialModal";

const inputDate = [
  { title: "Salary Form", subtitle: "$" },
  { title: "Salary To", subtitle: "$" },
  { title: "Enter City", subtitle: "$" },
  { title: "Enter State", subtitle: "State" },
  { title: "Enter Counter", subtitle: "State" },
  { title: "Enter Education Level", subtitle: "Education Level" },
];

const userDetails = JSON.parse(localStorage.getItem("userDetails"));
const userGender = userDetails?.user.gender;

function Basic({ title, subtitle }) {
  return (
    <div className="col-xl-6  col-md-6 mb-4">
      <label className="form-label font-w500">
        {title}
        <span className="text-danger ms-1">*</span>
      </label>
      <input
        type="text"
        className="w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder={subtitle}
        aria-label="name"
      />
    </div>
  );
}

const Header = ({ onNote, isSidebarCollapsed, toggleSidebar }) => {
  const location = useLocation();
  const pathToCheck = location.pathname.split("/")[1];
  const isCreateJobPage =
    location.pathname === "/new-job" ||
    location.pathname.startsWith("/update-job/");
  const isCreateOrEditOrgPage =
    location.pathname === "/super-admin/create-organisation" ||
    location.pathname.startsWith("/super-admin/edit-organisation/");

  const navigate = useNavigate();
  const { background, changeBackground } = useContext(ThemeContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTutorialOpen, setIsTutorialOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [expandedItems, setExpandedItems] = useState(() => {
    const location = window.location.pathname;
    const pathToCheck = location.split("/")[1];
    const currentMenu = pathToCheck === "super-admin" ? MenuSuperAdmin : MenuList;
    
    // Create an object with all items set to true (expanded)
    const allExpanded = {};
    currentMenu.forEach(item => {
      if (item.content && item.content.length > 0) {
        allExpanded[item.title] = true;
      }
    });
    
    return allExpanded;
  });
  const [state, setState] = useState({ active: "", activeMenu: "" });
  const [pendingCount, setPendingCount] = useState(0);

  // Get the user details
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userGender = userDetails?.user.gender;

  // Get the current menu based on the path
  const currentMenu = pathToCheck === "super-admin" ? MenuSuperAdmin : MenuList;

  // Add a ref for the profile dropdown
  const profileDropdownRef = useRef(null);

  useEffect(() => {
    // Check if the user is a Super Admin whenever the component mounts or user details change
    const superAdminUser = JSON.parse(localStorage.getItem("superAdminUser"));
    setIsSuperAdmin(!!superAdminUser);
  }, [location]);

  // Keep dropdown items expanded when menu changes
  useEffect(() => {
    const newExpandedItems = { ...expandedItems };
    currentMenu.forEach(item => {
      if (item.content && item.content.length > 0) {
        // Set new items to true if they don't exist in the current state
        if (newExpandedItems[item.title] === undefined) {
          newExpandedItems[item.title] = true;
        }
      }
    });
    setExpandedItems(newExpandedItems);
  }, [currentMenu]);

  // Add useEffect for polling
  useEffect(() => {
    // Function to fetch pending count
    const fetchPendingCount = async () => {
      try {
        const response = await JobActivityService.getPendingCount();
        setPendingCount(response.data.count);
      } catch (error) {
        console.error("Error fetching pending count:", error);
      }
    };

    // Fetch immediately on mount
    fetchPendingCount();

    // Set up polling interval
    const intervalId = setInterval(fetchPendingCount, 60000); // 60000ms = 1 minute

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Add useEffect for handling clicks outside the dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    // Add event listener when dropdown is open
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    
    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleCloseModal = () => setIsModalOpen(false);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const closeDropdown = () => setIsDropdownOpen(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleSubmenu = (title) => {
    setExpandedItems(prev => ({
      ...prev,
      [title]: !prev[title]
    }));
  };

  const handleMenuActive = (status, parent) => {
    setState({ active: parent, activeMenu: status });
  };

  const handleLinkClick = (e, title, parentTitle = null) => {
    e.preventDefault();
    const href = e.currentTarget.href;
    handleMenuActive(title, parentTitle);
    setIsMobileMenuOpen(false);
    setTimeout(() => {
      window.location.href = href;
    }, 0);
  };

  const handleThemeMode = () => {
    if (background.value === "dark") {
      changeBackground({ value: "light", label: "Light" });
    } else {
      changeBackground({ value: "dark", label: "Dark" });
    }
  };

  const getPageTitle = () => {
    const currentPath = location.pathname;
    console.log("Current path:", currentPath); // For debugging
    
    // First check if we're in super-admin section
    if (currentPath.includes("/super-admin/")) {
      // Find the matching menu item from MenuSuperAdmin
      for (const menuItem of MenuSuperAdmin) {
        if (menuItem.content) {
          const matchingItem = menuItem.content.find(item => {
            // Remove leading slash and super-admin/ from both paths for comparison
            const normalizedPath = currentPath.replace(/^\/super-admin\//, '');
            const itemPath = item.to.replace(/^\/super-admin\//, '');
            return normalizedPath.includes(itemPath);
          });
          if (matchingItem) {
            return matchingItem.title;
          }
        }
      }
    }
    
    // Use the existing path parsing logic for non-super-admin pages
    const pathSegments = window.location.pathname.split("/");
    const name = pathSegments[pathSegments.length - 1].split("-");
    let finalName = [];

    const jobLabel = getJobTitleLabel();
    if (pathSegments[1] === "update-job") {
      finalName = [`Update ${jobLabel}`];
    } else if (pathSegments[1] === "view-job") {
      finalName = [`${jobLabel} View`];
    } else {
      let filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
      finalName = filterName.includes("app");
      filterName =
        name.length >= 3
          ? name.filter((n, i) => i > 0)
          : name[0].length > 10
            ? [`${jobLabel} View`]
            : name;
      finalName = filterName.includes("app")
        ? filterName.filter((f) => f !== "app")
        : filterName.includes("ui")
          ? filterName.filter((f) => f !== "ui")
          : filterName.includes("uc")
            ? filterName.filter((f) => f !== "uc")
            : filterName.includes("basic")
              ? filterName.filter((f) => f !== "basic")
              : filterName.includes("jquery")
                ? filterName.filter((f) => f !== "jquery")
                : filterName.includes("table")
                  ? filterName.filter((f) => f !== "table")
                  : filterName.includes("page")
                    ? filterName.filter((f) => f !== "page")
                    : filterName.includes("email")
                      ? filterName.filter((f) => f !== "email")
                      : filterName.includes("ecom")
                        ? filterName.filter((f) => f !== "ecom")
                        : filterName.includes("chart")
                          ? filterName.filter((f) => f !== "chart")
                          : filterName.includes("editor")
                            ? filterName.filter((f) => f !== "editor")
                            : filterName;
    }

    // Format the final name into a proper title
    return finalName
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className={`header-wrapper ${isSidebarCollapsed ? 'menu-toggle' : ''}`}>
      <div className="flex-1 bg-white border-b flex items-center justify-between px-4 sm:px-6 shadow-sm">
        <div className="flex items-center">
          {/* Desktop Sidebar Toggle Button - Only visible when sidebar is collapsed */}
          {isSidebarCollapsed && (
            <button
              onClick={toggleSidebar}
              className="hidden lg:flex p-2 hover:bg-gray-100 rounded-lg transition-colors mr-3"
            >
              <FaBars className="text-[#0E4B4B] w-5 h-5" />
            </button>
          )}
          
          {/* Mobile Menu Button - Only visible on mobile when sidebar is collapsed */}
          {isSidebarCollapsed && (
            <button
              onClick={toggleSidebar}
              className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <div className="hamburger">
                <span className="block w-6 h-0.5 bg-[#0E4B4B] mb-1"></span>
                <span className="block w-6 h-0.5 bg-[#0E4B4B] mb-1"></span>
                <span className="block w-4 h-0.5 bg-[#0E4B4B]"></span>
              </div>
            </button>
          )}
          
          {/* <div className="lg:hidden ml-2">
            <Link to="/" className="text-[#0E4B4B] text-xl font-semibold">
              <img src={logo} alt="smarterView Logo" className="h-7 bg-white p-1 rounded" />
            </Link>
          </div> */}
          {/* <h1 className="hidden lg:block text-[#0E4B4B] text-base sm:text-lg font-medium truncate max-w-[200px] sm:max-w-none ml-2 lg:ml-0">
            {getPageTitle()}
          </h1> */}
        </div>

        {/* Right side - Icons */}
        <div className="flex items-center space-x-2 sm:space-x-4">


          {/* Profile Button and Dropdown */}
          <div className="relative" ref={profileDropdownRef}>
            <button
              onClick={toggleDropdown}
              className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-accent-light/10 transition-colors duration-200"
            >
              <div className="w-10 h-10 rounded-full bg-primary-headings flex items-center justify-center">
                <SlUser className="w-5 h-5 text-white" />
              </div>
              <div className="hidden md:block text-left">
                <p className="text-sm font-medium text-primary-headings">
                  {isSuperAdmin ? 'Super Admin' : userDetails?.user?.name?.split(' ').map(word => 
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  ).join(' ') || 'User'}
                </p>
              </div>
              <svg 
                className={`w-4 h-4 text-accent-dark transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-auto bg-white rounded-xl shadow-lg py-2 border border-accent-light/20 z-50">
                {/* Add arrow indicator */}
                <div className="absolute -top-2 right-6 w-4 h-4 rotate-45 bg-white border-l border-t border-accent-light/20"></div>
                
                {/* Header */}
                {userDetails?.user?.email && !isSuperAdmin &&
                  <div className="px-4 py-3 border-b-2 border-accent-light">
                    <p className="text-sm font-semibold text-accent-dark text-center">
                      {userDetails?.user?.email || ''}
                    </p>
                  </div>
                }

                {/* Menu Items */}
                <div className="py-2">
                  {!isSuperAdmin && (
                    <>
                      <button
                        onClick={() => {
                          setIsTutorialOpen(true);
                          closeDropdown();
                        }}
                        className="flex items-center w-full px-4 py-2.5 text-sm text-accent-dark hover:bg-accent-light/5 transition-colors duration-200"
                      >
                        <svg className="w-4 h-4 mr-3 text-primary-headings" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6l4 2m4-2a8 8 0 11-16 0 8 8 0 0116 0z" />
                        </svg>
                        View Tutorial
                      </button>
                      <button
                        onClick={() => {
                          setIsModalOpen(true);
                          closeDropdown();
                        }}
                        className="flex items-center w-full px-4 py-2.5 text-sm text-accent-dark hover:bg-accent-light/5 transition-colors duration-200"
                      >
                        <svg className="w-4 h-4 mr-3 text-primary-headings" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                        </svg>
                        Change Password
                      </button>
                    </>
                  )}
                  <button
                    onClick={() => {
                      localStorage.clear();
                      window.location.href = "/login";
                    }}
                    className="flex items-center w-full px-4 py-2.5 text-sm text-accent-dark hover:bg-accent-light/5 transition-colors duration-200"
                  >
                    <svg className="w-4 h-4 mr-3 text-primary-headings" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    Logout
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu Modal */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/30" onClick={toggleMobileMenu}></div>
          <div className="absolute left-0 top-0 h-full w-64 bg-[#0E4B4B] transform transition-transform duration-300 z-50 overflow-hidden">
            <div className="p-4 border-b border-white/10">
              <h2 className="text-sm font-medium text-white uppercase tracking-wider">Main Menu</h2>
            </div>
            <PerfectScrollbar className="h-[calc(100%-4rem)] overflow-x-hidden">
              <ul className="space-y-1 w-full">
                {currentMenu.map((data, index) => {
                  const isActive = state.active === data.title;
                  const isExpanded = expandedItems[data.title];
                  
                  if (data.classsChange === "menu-title") {
                    return (
                      <li key={index} className="px-4 py-2 text-sm font-medium text-white uppercase tracking-wider">
                        {data.title}
                      </li>
                    );
                  }
                  
                  return (
                    <li key={index} className="w-full">
                      {data.content && data.content.length > 0 ? (
                        <>
                          <button
                            onClick={() => toggleSubmenu(data.title)}
                            className={`w-full flex items-center px-4 py-2.5 text-sm transition-colors duration-200 ${
                              isActive
                                ? "text-white bg-[#126F6F]"
                                : "text-white hover:bg-[#0a3b3b]"
                            }`}
                          >
                            <span className="mr-3">{data.icon}</span>
                            <span className="font-medium flex-1 truncate">{data.title}</span>
                            <svg
                              className={`w-4 h-4 transition-transform duration-200 ${
                                isExpanded ? "rotate-180" : ""
                              } text-white`}
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </button>
                          <div className={`overflow-hidden transition-all duration-200 ${isExpanded ? "max-h-96" : "max-h-0"}`}>
                            <ul className="bg-[#0a3b3b] py-1 w-full">
                              {data.content.map((subData, index) => (
                                <li key={index} className="w-full">
                                  <Link
                                    to={subData.to}
                                    className={`flex items-center pl-12 pr-4 py-2.5 text-sm transition-colors duration-200 w-full ${
                                      state.activeMenu === subData.title
                                        ? "text-white bg-[#126F6F]"
                                        : "text-white hover:bg-[#126F6F]/30"
                                    }`}
                                    onClick={(e) => {
                                      e.currentTarget.blur();
                                      handleMenuActive(subData.title, data.title);
                                      setIsMobileMenuOpen(false);
                                    }}
                                  >
                                    <span className="mr-3 flex items-center">
                                      <span className="h-1.5 w-1.5 rounded-full bg-white mr-2"></span>
                                    </span>
                                    <span className="font-medium truncate">{subData.title}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </>
                      ) : (
                        <Link
                          to={data.to}
                          onClick={(e) => {
                            e.currentTarget.blur();
                            handleLinkClick(e, data.title);
                          }}
                          className={`flex items-center px-4 py-2.5 text-sm transition-colors duration-200 w-full ${
                            isActive
                              ? "text-white bg-[#126F6F]"
                              : "text-white hover:bg-[#0a3b3b]"
                          }`}
                        >
                          <span className="mr-3">{data.icon}</span>
                          <span className="font-medium truncate">{data.title}</span>
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </PerfectScrollbar>
          </div>
        </div>
      )}

      {!isSuperAdmin && (
        <ChangePasswordModal isOpen={isModalOpen} onClose={handleCloseModal} />
      )}
      {!isSuperAdmin && (
        <TutorialModal isOpen={isTutorialOpen} onClose={() => setIsTutorialOpen(false)} />
      )}
    </div>
  );
};

export default Header;
